import "./styleSheets/landingPage.css";
import ImageCarousel from "./imageGrid";
import React, { useEffect, useState } from "react";

const MakeupPage = () => {
  const [shmImages, setShmImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const loadImages = async () => {
      try {
        setIsLoading(true);
        setHasError(false);
        const response = await fetch("/makeupImages/list.json", {
          signal: controller.signal,
        });
        if (!response.ok) {
          throw new Error(`Failed to load images: ${response.status}`);
        }
        const data = await response.json();
        if (Array.isArray(data)) {
          setShmImages(data.map((file) => `/makeupImages/${file}`));
        } else {
          setShmImages([]);
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Could not load makeup image list.", error);
          setShmImages([]);
          setHasError(true);
        }
      } finally {
        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      }
    };

    loadImages();
    return () => controller.abort();
  }, []);

  return (
    <div className="makeupPage">
      <div className="info-section">
        <div className="landingBox">
          <h1>Hair & Beauty</h1>
          <p style={{ fontSize: "large", padding: "0 50px" }}>
            Step into a world of exquisite beauty with our comprehensive bridal,
            party makeup, and guest hairstyling services, tailored to perfection
            for your special occasions. From timeless bridal looks to glamorous
            party styles, our expert team crafts flawless makeup and hairstyles
            to enhance your natural beauty.
            <br />
            <br />
            Indulge in premium products and personalized touches that elevate
            your experience. Let us transform your moments into cherished
            memories, where every brushstroke and strand tells a tale of beauty
            and celebration...
          </p>
          <div className="styled-line"></div>
          <h2>Client/Model Work</h2>
          {isLoading && <p>Loading gallery...</p>}
          {hasError && (
            <p>We could not load images right now. Please refresh and try again.</p>
          )}
          <ImageCarousel slides={shmImages} />
        </div>
      </div>
    </div>
  );
};

export default MakeupPage;
